import React from 'react';
export var FontUpgradeContext = /*#__PURE__*/React.createContext({});